import { jsx as _jsx } from "react/jsx-runtime";
import './fullscreen.sass';
import { useCallback } from 'react';
import { IconButton } from '@mui/material';
import * as classnames from 'classnames';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { isFullScreenMode } from '../lib';
export const FullScreenButton = function FullScreenButton(props) {
    const [active, , , toggle] = useBooleanState(false);
    const is_fullscreen = isFullScreenMode();
    const onClick = useCallback((event) => {
        event.preventDefault();
        props.onClickFullScreen?.();
        toggle();
    }, [props]);
    return (_jsx(IconButton, { disableRipple: true, "aria-controls": "fullscreen", className: classnames(is_fullscreen ? 'ui-map-fullscreen on' : 'ui-map-fullscreen', { active }), onClick: onClick, title: is_fullscreen
            ? 'Выйти из полноэкранного режима'
            : 'Открыть карту на полный экран', size: "large" }));
};
